import api from './api';

const hoteltemplateService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.hotel_id) params.append('hotel_id', filters.hotel_id);
    const qs = params.toString();
    return api.get(qs ? `/hoteltemplates?${qs}` : '/hoteltemplates');
  },

  getById: async (id) => {
    return api.get(`/hoteltemplates/${id}`);
  },

  create: async (data) => {
    return api.post('/hoteltemplates', data);
  },

  update: async (id, data) => {
    return api.put(`/hoteltemplates/${id}`, data);
  },

  delete: async (id) => {
    return api.delete(`/hoteltemplates/${id}`);
  },

  // FULL DOCUMENT TEMPLATES — the whole document for one vault system group, as opposed to the
  // header/footer pair above. Same lambda, same screen; kept in this service rather than a new one so a
  // caller does not have to know that a hotel's templates are split across two tables.
  getAllFull: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.hotel_id) params.append('hotel_id', filters.hotel_id);
    if (filters.vault_source_group_id) params.append('vault_source_group_id', filters.vault_source_group_id);
    const qs = params.toString();
    return api.get(qs ? `/hotelfulltemplates?${qs}` : '/hotelfulltemplates');
  },

  getFullById: async (id) => api.get(`/hotelfulltemplates/${id}`),

  createFull: async (data) => api.post('/hotelfulltemplates', data),

  updateFull: async (id, data) => api.put(`/hotelfulltemplates/${id}`, data),

  deleteFull: async (id) => api.delete(`/hotelfulltemplates/${id}`)
};

export default hoteltemplateService;
